var Component = require("!../../../../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../vue-loader/lib/selector?type=script&index=0!./rtVerticalAttr.vue"),
  /* template */
  require("!!../../../../../vue-loader/lib/template-compiler/index?{\"id\":\"data-v-3193d86c\"}!../../../../../vue-loader/lib/selector?type=template&index=0!./rtVerticalAttr.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/vue-xpc/src/components/business/common/rtVerticalAttr.vue
// module id = 1913
// module chunks = 137